import React, { Component, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { LineChart, XAxis, YAxis, Line, CartesianGrid, ResponsiveContainer, Tooltip, Legend } from "recharts";
import { Form } from "react-form";
import Grid from "@material-ui/core/Grid";
import { createSelector } from "../../common/orm";
import Button from "@material-ui/core/Button";
import SectionTabHeader from "./SectionTabHeader";
import TopButtons from "./TopButtons";
import AppContainer from "../../common/AppContainer";
import { Typography } from "@material-ui/core";
import Select from "../../common/Select";
import TextField from "../../common/TextField";
import DatePicker from "../../common/DatePicker";
import { getCSRFToken } from '../../common/Csrf'
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useReactToPrint } from "react-to-print";
import ReactExport from "react-export-excel-xlsx-fix";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Download extends Component {
    render() {
        const { title, chart_data } = this.props;
        return (
            <ExcelFile filename={title} element={<Button color="primary" style={{textAlign:"left", marginTop: 16}} variant="contained" fullWidth>
                Export to Excel
            </Button>}>
                <ExcelSheet data={chart_data.data} name="Data">
                    <ExcelColumn label="Date" value="date_text"/>
                    {chart_data.fields.map((fi) => {
                        return (
                            <ExcelColumn label={fi.name} value={fi.id}/>
                        )
                    })}
                    <ExcelColumn label="URL" value="url"/>
                </ExcelSheet>
            </ExcelFile>
        );
    }
}

const getPermission = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["pageId"]),
    (session, pageID) => {
        return session.Permission.filter((p) => p.page === pageID).toRefArray();
    }
);

const getPage = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["pageId"]),
    (session, pageID) => {
        return session.Page.withId(pageID);
    }
);

const getSection = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["sectionId"]),
    (session, sectionId) => {
        return session.Section.withId(sectionId);
    }
);

const getParentRecordId = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["parentRecordId"]),
    (session, parentRecord) => {
        return parentRecord;
    }
);

const getRecordSection = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["parentRecordId"]),
    (session, pr) => {
        return session.RecordSection.filter((rs) => rs.parentrecord === pr).toRefArray();
    }
);

function MAKE_OPTIONS(table) {
    return table.map((row) => ({
        label: row.unit ? row.name + " (" + row.unit + ")" : row.name,
        value: row.id,
    }));
}

class CustomizedAxisTick extends Component {
    render() {
        const { x, y, payload } = this.props;
        var d = new Date(payload.value);
  
        return (
            <g transform={`translate(${x},${y})`}>
                <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-35)">
                    {d.toLocaleString('default', { month: 'short', year: 'numeric' })}
                </text>
            </g>
        );
    }
}

// eslint-disable-next-line
Array.prototype.hasMax = function(attrib) {
    const checker = (o, i) => typeof(o) === 'object' && o[i]
    return (this.length && this.reduce(function(prev, curr){
        const prevOk = checker(prev, attrib);
        const currOk = checker(curr, attrib);
        if (!prevOk && !currOk) return {};
        if (!prevOk) return curr;
        if (!currOk) return prev;
        return prev[attrib] > curr[attrib] ? prev : curr; 
    })) || null;
}
// eslint-disable-next-line
Array.prototype.hasMin = function(attrib) {
    const checker = (o, i) => typeof(o) === 'object' && o[i]
    return (this.length && this.reduce(function(prev, curr){
        const prevOk = checker(prev, attrib);
        const currOk = checker(curr, attrib);
        if (!prevOk && !currOk) return {};
        if (!prevOk) return curr;
        if (!currOk) return prev;
        return prev[attrib] < curr[attrib] ? prev : curr; 
    })) || null;
}

class RecordSectionChart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingFeatures: false,
            chart_data: null,
        };
    }

    componentDidMount() {
        this.loadFeatures();
    };

    componentDidUpdate(prevProps) {
        const { section } = this.props;
        if (section && section.id !== prevProps?.section?.id)
            this.loadFeatures();
    };

    loadFeatures() {
        const { section, parentrecordid, authState } = this.props;
        const { loadingFeatures } = this.state;
        var component = this;

        if (parentrecordid && section && !loadingFeatures) {
            this.setState({ loadingFeatures: true, chart_data: null }); 
            
            let options = {
                method: "POST",
                headers: {
                    "X-CSRFToken": getCSRFToken(),
                }
            };
            
            fetch(`/chart/${section.id}/${parentrecordid}?t=${Date.now()}`, options).then((result) => 
                result.json()
            ).then((data) => {
                data.data.forEach(d => {
                    d.date_real = new Date(d.date_text).valueOf()
                });
                component.setState({ chart_data: data, loadingFeatures: false });
            });
        }
    };

    render() {
        const { authState, permission, page, rs, section, mediaQuery } = this.props;
        const { loadingFeatures, chart_data } = this.state;

        if (!page) return "";

        // This should be in topbuttons?
        if (authState.user) {
            var perm = permission.find((p) => {
                if (p.user === authState.user.id) {
                    return p;
                }
                return null;
            });
        }

        if (loadingFeatures || !chart_data || chart_data?.length === 0) {
            return (
                <AppContainer authenticated>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid item xs={12}>
                                <TopButtons perm={perm} section={section} page={page} authState={authState} showPageName={true} />
                            </Grid>
                            <SectionTabHeader value={section.id} />
                        </Grid>
                        <Grid item xs={12} style={{marginTop: 160 }}>
                            {chart_data?.length === 0 ? (
                                <Typography variant="h5" style={{textAlign:"center"}}>Chart misconfiguration. Check settings.</Typography>
                            ) : (
                                <>
                                <CircularProgress
                                    size={72}
                                    style={{ display: "table", marginLeft: "auto", marginRight: "auto", zIndex:90000 }}
                                /> 
                                <Typography variant="h5" style={{textAlign:"center"}}>Loading Chart...</Typography>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </AppContainer>
            );
        }

        var title = `${page.name} ${rs && rs[0].parentinfo && " - " + rs[0].parentinfo.label}`;

        return (
            <AppContainer authenticated>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid item xs={12}>
                            <TopButtons perm={perm} section={section} page={page} authState={authState} showPageName={true} />
                        </Grid>
                        <SectionTabHeader value={section.id} />
                    </Grid>
                    <Grid item xs={12} style={{marginTop: 124 }}>
                        <ChartGridComponent 
                            chart_data={chart_data}
                            section={section}
                            mediaQuery={mediaQuery}
                            title={title}
                        />
                    </Grid>
                </Grid>
            </AppContainer>
        );
    }
}

// Make function based component to support react print....
function ChartGridComponent({chart_data, section, mediaQuery, title}) {
    const [field_charted, set_field_charted] = useState(null);
    const [field_charted2, set_field_charted2] = useState(null);
    const [start_date, set_start_date] = useState(null);
    const [end_date, set_end_date] = useState(null);
    const [min_value, set_min_value] = useState(null);
    const [max_value, set_max_value] = useState(null);
    const componentRef = React.useRef(null);

    const printFn = useReactToPrint({
        contentRef: componentRef,
        documentTitle: title,
    });

    const handleClick = (e) => {
        window.open(e.payload.url)
    };

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            var field_data = chart_data.fields.find(c => c.id.toString() === payload[0].dataKey.toString());
            var d = new Date(label);
            var field_data2;
            if (payload[1]) {
                field_data2 = chart_data.fields.find(c => c.id.toString() === payload[1].dataKey.toString());
            }
            
            return (
                <div 
                    style={{
                        margin: 0,
                        padding: 10,
                        backgroundColor: "rgb(255, 255, 255)",
                        border: "1px solid rgb(204, 204, 204)",
                        whiteSpace: "nowrap"
                    }}
                >
                    <Typography>{d.toLocaleDateString()}</Typography>
                    <Typography>{field_data.name + ": " + payload[0].value}</Typography>
                    {field_data2 && (
                        <Typography>{field_data2.name + ": " + payload[1].value}</Typography>
                    )}
                    <Typography><i>Click on dot to open record</i></Typography>
                </div>
            );
        }
      
        return null;
    };

    const legendFormatter = (value, entry) => {
        const {  dataKey, payload } = entry;
        var field_data = chart_data.fields.find(c => c.id.toString() === dataKey.toString());

        return <span style={{color: payload.dot.stroke}}>{field_data.name}</span>;
    }

    var field_to_use, field_to_use2;
    if (field_charted) {
        field_to_use = chart_data.fields.find(c => c.id.toString() === field_charted.toString())
    } else {
        field_to_use = chart_data.fields[0];
    }
    var axis_label = field_to_use.unit ? field_to_use.name + " (" + field_to_use.unit + ")" : field_to_use.name;
    var axis_label2;
    if (field_charted2) {
        field_to_use2 = chart_data.fields.find(c => c.id.toString() === field_charted2.toString());
        axis_label2 = field_to_use2.unit ? field_to_use2.name + " (" + field_to_use2.unit + ")" : field_to_use2.name;
    }
  
    return (
        <Grid container>
            <Grid item xs={12} lg={9} ref={componentRef}>
                <style type="text/css" media="print">{"\
                    @page { size: landscape; }\
                "}</style>
                <Typography variant="h5" style={{textAlign:"center"}}>
                    {title}
                </Typography>
                <ResponsiveContainer width='100%' height={600}>
                    <LineChart 
                        height={600} data={chart_data.data} margin={{ top: 24, right: 24, bottom: 24, left: 24 }}>
                        <Line
                            type="monotone"
                            dataKey={field_charted || chart_data.fields[0].id}
                            stroke={section.chart_line_color}
                            strokeWidth={section.chart_line_width}
                            dot={{ stroke: section.chart_point_color, strokeWidth: section.chart_point_size }}
                            activeDot={{ onClick: handleClick }}
                            yAxisId="left"
                        />
                        {field_charted2 && (
                            <Line
                                type="monotone"
                                dataKey={field_charted2}
                                stroke={section.chart_line_color2}
                                strokeWidth={section.chart_line_width2}
                                dot={{ stroke: section.chart_point_color2, strokeWidth: section.chart_point_size2 }}
                                activeDot={{ onClick: handleClick }}
                                yAxisId="right"
                            />
                        )}
                        <Tooltip content={CustomTooltip} />
                        <CartesianGrid 
                            //horizontalCoordinatesGenerator={(props) => props.height > 250 ? [75, 150, 225] : [100, 200]} 
                            stroke="#ccc" 
                            strokeDasharray="5 5" 
                        />
                        <XAxis 
                            allowDataOverflow 
                            padding={{ left: 8, right: 8 }} 
                            domain={[start_date || 'dataMin', end_date || 'dataMax']} 
                            tickCount={50}
                            tick={<CustomizedAxisTick />} 
                            type="number" 
                            dataKey="date_real" 
                        />
                        <YAxis 
                            allowDataOverflow 
                            padding={{ top: 8, bottom: 8 }} 
                            domain={[min_value || 'dataMin', max_value || 'dataMax']} 
                            yAxisId="left"
                            tickCount={20}
                            label={{ 
                                style: {fontSize: 15, fontFamily: "'Source Sans Pro', sans-serif"}, 
                                value: axis_label, 
                                angle: -90, 
                                position: 'insideLeft',
                                offset: -16
                            }} 
                        />
                        {field_charted2 && (
                            <YAxis 
                                allowDataOverflow 
                                padding={{ top: 8, bottom: 8, right: 40 }} 
                                domain={['dataMin', 'dataMax']} 
                                tickCount={20}
                                orientation="right"
                                yAxisId="right"
                                label={{ 
                                    style: {fontSize: 15, fontFamily: "'Source Sans Pro', sans-serif"}, 
                                    value: axis_label2, 
                                    angle: -90, 
                                    position: 'right',
                                    offset: 0
                                }} 
                            />
                        )}
                        <Legend     
                            formatter={legendFormatter}
                            wrapperStyle={{
                                paddingTop: "32px"
                            }} 
                        />
                    </LineChart>
                </ResponsiveContainer>
            </Grid>
            <Grid item xs={12} lg={3} style={{marginTop: !mediaQuery && 16, borderTop: !mediaQuery && "1px solid", borderLeft: mediaQuery && "1px solid"}}>
                <Form dontValidateOnMount={true} defaultValues={{field_charted: chart_data.fields[0].id, start_date: null, end_date: null}} >
                    {(formApi) => (
                        <form onSubmit={formApi.submitForm}>
                            <div style={{marginLeft: 16}}>
                                <Typography style={{textAlign:"center"}} variant="h5">Chart Options</Typography>
                                <Select
                                    field="field_charted"
                                    label="Field Charted"
                                    style={{marginBottom: 16}}
                                    options={MAKE_OPTIONS(chart_data.fields)}
                                    fullWidth
                                    eventHandle={(value) =>
                                        set_field_charted(value)
                                    }
                                />
                                <Select
                                    field="field_charted2"
                                    label="Chart Second Field"
                                    options={
                                        [
                                            {"label": "-", value: null}, 
                                            ...MAKE_OPTIONS(chart_data.fields)
                                        ]
                                    }
                                    fullWidth
                                    eventHandle={(value) =>
                                        set_field_charted2(value)
                                    }
                                />
                                <Typography variant="h4" style={{marginTop: 16, textAlign:"center"}} gutterBottom>Summary Statistics</Typography>
                                <Typography gutterBottom>Period: <b>{chart_data.data[0].date_text} - {chart_data.data[chart_data.data.length - 1].date_text}</b></Typography>
                                <Typography gutterBottom>Minimum Value: <b>{chart_data.data.hasMin(field_charted || chart_data.fields[0].id)[field_charted || chart_data.fields[0].id]}</b></Typography>
                                <Typography gutterBottom>Maximum Value: <b>{chart_data.data.hasMax(field_charted || chart_data.fields[0].id)[field_charted || chart_data.fields[0].id]}</b></Typography>
                                <Typography variant="h4" style={{marginTop: 16, textAlign:"center"}}>Filter Data</Typography>
                                <DatePicker 
                                    field="start_date" 
                                    style={{marginTop: 16}} 
                                    label="Start Date" 
                                    fullWidth 
                                    eventHandle={(value) =>
                                        set_start_date(new Date(value).valueOf())
                                    }
                                />
                                <DatePicker 
                                    field="end_date" 
                                    style={{marginTop: 16}} 
                                    label="End Date" 
                                    fullWidth 
                                    eventHandle={(value) =>
                                        set_end_date(new Date(value).valueOf())
                                    }
                                />
                                <TextField
                                    field="min_value"
                                    label="Minimum Value"  
                                    style={{marginTop: 16}}
                                    fullWidth
                                    useNumberFormat3
                                    eventHandle={(value) =>
                                        set_min_value(parseFloat(value))
                                    }
                                />
                                <TextField
                                    field="max_value"
                                    label="Maximum Value"  
                                    style={{marginTop: 16}}
                                    fullWidth
                                    useNumberFormat3
                                    eventHandle={(value) =>
                                        set_max_value(parseFloat(value))
                                    }
                                />
                                <Download title={title} chart_data={chart_data} />
                                <Button onClick={printFn} color="primary" style={{textAlign:"left", marginTop: 16}} variant="contained" fullWidth>
                                    Print Chart
                                </Button>
                            </div>
                        </form>
                    )}
                </Form>
            </Grid>
        </Grid>
    );
}

RecordSectionChart.displayName = "RecordSectionChart";

RecordSectionChart = connect(
    (state, ownProps) => ({
        authState: state.auth,
        permission: getPermission(state, ownProps),
        page: getPage(state, ownProps),
        section: getSection(state, ownProps),
        parentrecordid: getParentRecordId(state, ownProps),
        rs: getRecordSection(state, ownProps),
    }), null
)(RecordSectionChart);


const withMediaQuery = (...args) => Component => props => {
    const mediaQuery = useMediaQuery(...args);
    return <Component mediaQuery={mediaQuery} {...props} />;
};

export default withMediaQuery('(min-width:1280px)')(withRouter(RecordSectionChart));
